export const timeZone = 'Asia/Taipei'

export const agentsCsLink = 'https://tawk.to/chat/680b539b29a5a6191417a0ef/1ipm3t5vk'
export const chatsCsLink = 'https://tawk.to/chat/680b5370bb1753191a4dd141/1ipm3rs99'
export const chatsPlayCsLink = 'https://tawk.to/chat/6810947400e88619103f14dd/1iq0c7q5q'

export const maxBetNumbers = 9_990

// 預留封盤 20 20 120
export const defaultReservedCloseTime = 20
export const minCloseTime = 20
export const maxCloseTime = 120

// 延遲報網 0 0 10
export const defaultCallDelay = 0
export const minCallDelay = 0
export const maxCallDelay = 10

/* 机器人配置 */

export const defaultMaxWorkingRobots = 20

// 最小开始投注时间 20 20 180
export const defaultRobotMinBetStart = 20
export const minRobotMinBetStart = 20
export const maxRobotMinBetStart = 180

// nob3 最小开始投注时间 30 20 120
export const defaultNob3RobotMinBetStart = 20
export const minNob3RobotMinBetStart = 20
export const maxNob3RobotMinBetStart = 120

// 最大开始投注时间 150 20 180
export const defaultRobotMaxBetStart = 50
export const minRobotMaxBetStart = 20
export const maxRobotMaxBetStart = 180

// nob3 最大开始投注时间 60 20 120
export const defaultNob3RobotMaxBetStart = 50
export const minNob3RobotMaxBetStart = 20
export const maxNob3RobotMaxBetStart = 120

export const maxDeposit = 100_000
export const maxWithdrawal = 100_000

// 最小上分 1000 0 20000
export const defaultRobotMinDeposit = 1000
export const minRobotMinDeposit = 0
export const maxRobotMinDeposit = 20_000

// 最大上分 5000 0 20000
export const defaultRobotMaxDeposit = 5000
export const minRobotMaxDeposit = 0
export const maxRobotMaxDeposit = 20_000

// 最小下分 1000 0 20000
export const defaultRobotMinWithdrawal = 1000
export const minRobotMinWithdrawal = 0
export const maxRobotMinWithdrawal = 20_000

// 最大下分 5000 0 20000
export const defaultRobotMaxWithdrawal = 5000
export const minRobotMaxWithdrawal = 0
export const maxRobotMaxWithdrawal = 20_000

// 最大分 20000 20000 50000
export const defaultRobotMaxScore = 20_000
export const minRobotMaxScore = 20_000
export const maxRobotMaxScore = 50_000

// 机器人数量-最小 1 0 20
export const defaultRobotMinRobots = 1
export const minRobotMinRobots = 0
export const maxRobotMinRobots = 20

// 机器人数量-最大 5 0 20
export const defaultRobotMaxRobots = 5
export const minRobotMaxRobots = 0
export const maxRobotMaxRobots = 20

/* 賠率限額 */

export const defaultBetRatioOne = 9.6
export const defaultBetRatioTwo = 96
export const defaultBetRatioThree = 960
export const defaultBetRatioFour = 9_600

export const maxBetRatioOne = 10
export const maxBetRatioTwo = 100
export const maxBetRatioThree = 1000
export const maxBetRatioFour = 10_000

export const minBetRatio = 1

export const minBetAmountOne = 1
export const minBetAmountTwo = 1
export const minBetAmountThree = 0.1
export const minBetAmountFour = 0.1

export const maxBetAmountOne = 5000
export const maxBetAmountTwo = 1000
export const maxBetAmountThree = 50
export const maxBetAmountFour = 10

export const minSinglePlayAmountOne = 1
export const minSinglePlayAmountTwo = 1
export const minSinglePlayAmountThree = 0.1
export const minSinglePlayAmountFour = 0.1

export const maxSinglePlayAmountOne = 10_000
export const maxSinglePlayAmountTwo = 1000
export const maxSinglePlayAmountThree = 100
export const maxSinglePlayAmountFour = 20

export const defaultFanBetRatio = 3.991
export const defaultFanZhengBetRatio = 1.975
export const defaultFanNianBetRatio = 2.963
export const defaultFanJiaoBetRatio = 1.975
export const defaultFanDanBetRatio = 1.975
export const defaultFanShuangBetRatio = 1.975
export const defaultFanDaBetRatio = 1.975
export const defaultFanXiaoBetRatio = 1.975
export const defaultFanTongBetRatio = 1.481
export const defaultFanZhongBetRatio = 1.316
export const defaultFanJiaBetRatio = 1.975
export const defaultFanTeBetRatio = 19.83
export const defaultFanTeDanBetRatio = 1.98
export const defaultFanTeShuangBetRatio = 1.98
export const defaultFanTeDaBetRatio = 1.98
export const defaultFanTeXiaoBetRatio = 1.98

export const maxFanBetRatio = 4
export const maxFanZhengBetRatio = 2
export const maxFanNianBetRatio = 3
export const maxFanJiaoBetRatio = 2
export const maxFanDanBetRatio = 2
export const maxFanShuangBetRatio = 2
export const maxFanDaBetRatio = 2
export const maxFanXiaoBetRatio = 2
export const maxFanTongBetRatio = 1.5
export const maxFanZhongBetRatio = 1.333
export const maxFanJiaBetRatio = 2
export const maxFanTeBetRatio = 19.83
export const maxFanTeDanBetRatio = 1.98
export const maxFanTeShuangBetRatio = 1.98
export const maxFanTeDaBetRatio = 1.98
export const maxFanTeXiaoBetRatio = 1.98

export const minFanBetAmount = 10
export const maxFanBetAmount = 20_000
export const minFanSinglePlayAmount = 10
export const maxFanSinglePlayAmount = 100_000

export const defaultMinNumberOfRobots = 1
export const defaultMaxNumberOfRobots = 5
export const minNumberOfRobots = 0
export const maxNumberOfRobots = 20

export const defaultFanBetSettings = {
  fan: {
    bet_ratio: defaultFanBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  zheng: {
    bet_ratio: defaultFanZhengBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  nian: {
    bet_ratio: defaultFanNianBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  jiao: {
    bet_ratio: defaultFanJiaoBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  dan: {
    bet_ratio: defaultFanDanBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  shuang: {
    bet_ratio: defaultFanShuangBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  da: {
    bet_ratio: defaultFanDaBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  xiao: {
    bet_ratio: defaultFanXiaoBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  tong: {
    bet_ratio: defaultFanTongBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  zhong: {
    bet_ratio: defaultFanZhongBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  jia: {
    bet_ratio: defaultFanJiaBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
}

export const defaultNob8FanBetSettings = {
  fan: {
    bet_ratio: defaultFanBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  zheng: {
    bet_ratio: defaultFanZhengBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  nian: {
    bet_ratio: defaultFanNianBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  jiao: {
    bet_ratio: defaultFanJiaoBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  dan: {
    bet_ratio: defaultFanDanBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  shuang: {
    bet_ratio: defaultFanShuangBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  da: {
    bet_ratio: defaultFanDaBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  xiao: {
    bet_ratio: defaultFanXiaoBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  tong: {
    bet_ratio: defaultFanTongBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  zhong: {
    bet_ratio: defaultFanZhongBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  jia: {
    bet_ratio: defaultFanJiaBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },

  te: {
    bet_ratio: defaultFanTeBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  te_dan: {
    bet_ratio: defaultFanTeDanBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  te_shuang: {
    bet_ratio: defaultFanTeShuangBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  te_da: {
    bet_ratio: defaultFanTeDaBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
  te_xiao: {
    bet_ratio: defaultFanTeXiaoBetRatio,
    min_bet_amount: minFanBetAmount,
    max_single_bet_amount: maxFanBetAmount,
    max_signel_play_amount: maxFanSinglePlayAmount,
  },
}

export const limits = {
  C2: {
    defaultBetRatioOne: 9.8,
    defaultBetRatioTwo: 98,
    defaultBetRatioThree: 950,
    minBetAmountTwo: 0.1,
    maxBetAmountOne: 2000,
    maxBetAmountTwo: 500,
    maxBetAmountThree: 50,
    minSinglePlayAmountTwo: 0.1,
    maxSinglePlayAmountOne: 20_000,
    maxSinglePlayAmountTwo: 2000,
    maxSinglePlayAmountThree: 200,
    fan: {
      fan: {
        bet_ratio: 3.91,
        min_bet_amount: minFanBetAmount,
        max_single_bet_amount: maxFanBetAmount,
        max_signel_play_amount: maxFanSinglePlayAmount,
      },
      zheng: {
        bet_ratio: 1.97,
        min_bet_amount: minFanBetAmount,
        max_single_bet_amount: maxFanBetAmount,
        max_signel_play_amount: maxFanSinglePlayAmount,
      },
      nian: {
        bet_ratio: 1.97,
        min_bet_amount: minFanBetAmount,
        max_single_bet_amount: maxFanBetAmount,
        max_signel_play_amount: maxFanSinglePlayAmount,
      },
      jiao: {
        bet_ratio: 1.97,
        min_bet_amount: minFanBetAmount,
        max_single_bet_amount: maxFanBetAmount,
        max_signel_play_amount: maxFanSinglePlayAmount,
      },
      dan: {
        bet_ratio: 1.97,
        min_bet_amount: minFanBetAmount,
        max_single_bet_amount: maxFanBetAmount,
        max_signel_play_amount: maxFanSinglePlayAmount,
      },
      shuang: {
        bet_ratio: 1.97,
        min_bet_amount: minFanBetAmount,
        max_single_bet_amount: maxFanBetAmount,
        max_signel_play_amount: maxFanSinglePlayAmount,
      },
      da: {
        bet_ratio: 1.97,
        min_bet_amount: minFanBetAmount,
        max_single_bet_amount: maxFanBetAmount,
        max_signel_play_amount: maxFanSinglePlayAmount,
      },
      xiao: {
        bet_ratio: 1.97,
        min_bet_amount: minFanBetAmount,
        max_single_bet_amount: maxFanBetAmount,
        max_signel_play_amount: maxFanSinglePlayAmount,
      },
      tong: {
        bet_ratio: 1.485,
        min_bet_amount: minFanBetAmount,
        max_single_bet_amount: maxFanBetAmount,
        max_signel_play_amount: maxFanSinglePlayAmount,
      },
      zhong: {
        bet_ratio: 1.323,
        min_bet_amount: minFanBetAmount,
        max_single_bet_amount: maxFanBetAmount,
        max_signel_play_amount: maxFanSinglePlayAmount,
      },
      jia: {
        bet_ratio: 1.97,
        min_bet_amount: minFanBetAmount,
        max_single_bet_amount: maxFanBetAmount,
        max_signel_play_amount: maxFanSinglePlayAmount,
      }
    }
  }
}
